<template>
  <div id="VodTestMain" align="center" valign="center">
    <SysEnvTest />
    <NetEnvTest />
    <VodEnvTest />
  </div>
</template>

<script>
import VodEnvTest from './VodEnvTest'
import NetEnvTest from './NetEnvTest'
import SysEnvTest from './SysEnvTest'
export default {
  name: 'VodTestMain',
  components: {
    VodEnvTest,
    NetEnvTest,
    SysEnvTest
  },
  methods: {
    reTest() {
      window.location.reload()
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .cell {
  display: flex;
  align-items: center;
}
.test-again {
  height: 40px;
  padding: 30px 0 30px;
  text-align: center;
}
</style>
